import ShareableLinkLockScreen from './ShareableLinkLockScreen.component';

export default ShareableLinkLockScreen;